import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 线上的
    // $url: "https://api.hwkjpay.com/",
    $url: "",
    $imgUrl: "https://merchant-1317461711.cos.ap-nanjing.myqcloud.com/",
    // 上传
    $uploadUrl: "https://api.hwkjpay.com/upload/index",

    $token: window.localStorage.getItem("$token")
      ? window.localStorage.getItem("$token")
      : "",
    $user: window.localStorage.getItem("newHongWen")
      ? JSON.parse(window.localStorage.getItem("newHongWen"))
      : {},
    $isCollapse: false
  },
  mutations: {
    token(state, weather) {
      state.$token = weather;
    },
    user(state, weather) {
      state.$user = weather;
    },
    Collapse(state, weather) {
      state.$isCollapse = !state.$isCollapse;
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js